'use client';

import { useContext } from 'react';
import { MasterTimelineContext } from 'contexts/MasterTimelineContext';

export { MasterTimelineProvider } from 'contexts/MasterTimelineContext';

export const useMasterTimeline = () => useContext(MasterTimelineContext);
